import type { Category } from "../types/category";

// Türkiye için en çok aranan kategoriler - varsayılan set
export const DEFAULT_CATEGORIES: Category[] = [
  {
    id: "haber",
    name: "Haber",
    slug: "haber",
    icon: "ri-newspaper-line",
    seoTitle: "Türkiye Haber Telegram Kanalları ve Grupları | KanalRehberi",
    seoDescription: "Türkiye'nin en güncel haber Telegram kanalları. Son dakika haberleri, gündem, politika ve daha fazlası için en iyi haber kanallarını keşfedin.",
    order: 1,
    isFeatured: true
  },
  {
    id: "ekonomi-borsa",
    name: "Ekonomi & Borsa",
    slug: "ekonomi-borsa",
    icon: "ri-line-chart-line",
    seoTitle: "Ekonomi & Borsa Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Borsa İstanbul, döviz kurları, altın fiyatları ve ekonomi haberleri için en iyi Telegram kanalları. Yatırım tavsiyeleri ve piyasa analizleri.",
    order: 2,
    isFeatured: true
  },
  {
    id: "kripto",
    name: "Kripto",
    slug: "kripto",
    icon: "ri-bitcoin-line",
    seoTitle: "Kripto Para Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Bitcoin, Ethereum ve altcoin haberleri için en iyi kripto para Telegram kanalları. Kripto analiz, sinyal ve yatırım tavsiyeleri.",
    order: 3,
    isFeatured: true
  },
  {
    id: "futbol-spor",
    name: "Futbol & Spor",
    slug: "futbol-spor",
    icon: "ri-football-line",
    seoTitle: "Futbol & Spor Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Süper Lig, Avrupa ligleri, maç özetleri ve spor haberleri için en iyi Telegram kanalları. Canlı skor ve transfer haberleri.",
    order: 4,
    isFeatured: true
  },
  {
    id: "film-dizi",
    name: "Film & Dizi",
    slug: "film-dizi",
    icon: "ri-movie-line",
    seoTitle: "Film & Dizi Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "En yeni filmler, diziler, Netflix önerileri ve sinema haberleri için en iyi Telegram kanalları. Film ve dizi önerileri.",
    order: 5,
    isFeatured: true
  },
  {
    id: "teknoloji",
    name: "Teknoloji",
    slug: "teknoloji",
    icon: "ri-smartphone-line",
    seoTitle: "Teknoloji Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Teknoloji haberleri, akıllı telefon incelemeleri, gadget önerileri ve teknoloji dünyasından haberler için en iyi Telegram kanalları.",
    order: 6,
    isFeatured: true
  },
  {
    id: "yazilim",
    name: "Yazılım",
    slug: "yazilim",
    icon: "ri-code-line",
    seoTitle: "Yazılım & Programlama Telegram Kanalları | Türkiye",
    seoDescription: "Yazılım geliştirme, programlama dilleri, web tasarım ve kodlama öğrenmek için en iyi Telegram kanalları. Developer topluluğu.",
    order: 7,
    isFeatured: false
  },
  {
    id: "egitim",
    name: "Eğitim",
    slug: "egitim",
    icon: "ri-book-open-line",
    seoTitle: "Eğitim Telegram Kanalları - YKS, KPSS, DGS | Türkiye",
    seoDescription: "YKS, KPSS, DGS, ALES sınav hazırlık, ders notları ve eğitim içerikleri için en iyi Telegram kanalları. Ücretsiz eğitim kaynakları.",
    order: 8,
    isFeatured: false
  },
  {
    id: "is-ilanlari",
    name: "İş İlanları",
    slug: "is-ilanlari",
    icon: "ri-briefcase-line",
    seoTitle: "İş İlanları Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Güncel iş ilanları, kariyer fırsatları, staj ilanları ve iş bulma için en iyi Telegram kanalları. Remote iş fırsatları.",
    order: 9,
    isFeatured: false
  },
  {
    id: "kampanya-indirim",
    name: "Kampanya & İndirim",
    slug: "kampanya-indirim",
    icon: "ri-price-tag-3-line",
    seoTitle: "Kampanya & İndirim Telegram Kanalları | Türkiye",
    seoDescription: "En iyi indirim fırsatları, kampanyalar, kupon kodları ve alışveriş fırsatları için Telegram kanalları. Günlük indirim bildirimleri.",
    order: 10,
    isFeatured: false
  },
  {
    id: "oyun",
    name: "Oyun",
    slug: "oyun",
    icon: "ri-gamepad-line",
    seoTitle: "Oyun Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Oyun haberleri, oyun incelemeleri, e-spor ve gaming topluluğu için en iyi Telegram kanalları. PC, konsol ve mobil oyunlar.",
    order: 11,
    isFeatured: false
  },
  {
    id: "kitap-pdf",
    name: "Kitap & PDF",
    slug: "kitap-pdf",
    icon: "ri-book-line",
    seoTitle: "Kitap & PDF Telegram Kanalları | Türkiye",
    seoDescription: "Ücretsiz e-kitap, PDF kitap paylaşımı, kitap önerileri ve okuma topluluğu için en iyi Telegram kanalları.",
    order: 12,
    isFeatured: false
  },
  {
    id: "muzik",
    name: "Müzik",
    slug: "muzik",
    icon: "ri-music-line",
    seoTitle: "Müzik Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Türkçe ve yabancı müzik paylaşımı, şarkı sözleri, konser haberleri ve müzik topluluğu için en iyi Telegram kanalları.",
    order: 13,
    isFeatured: false
  },
  {
    id: "universite",
    name: "Üniversite",
    slug: "universite",
    icon: "ri-graduation-cap-line",
    seoTitle: "Üniversite Telegram Kanalları ve Grupları | Türkiye",
    seoDescription: "Üniversite öğrencileri için ders notları, sınav soruları, kampüs haberleri ve öğrenci topluluğu Telegram kanalları.",
    order: 14,
    isFeatured: false
  },
  {
    id: "ikinci-el",
    name: "2. El / Al-Sat",
    slug: "ikinci-el",
    icon: "ri-shopping-bag-line",
    seoTitle: "İkinci El Al-Sat Telegram Kanalları | Türkiye",
    seoDescription: "İkinci el eşya alım satımı, letgo, sahibinden ilanları ve pazarlık için en iyi Telegram kanalları ve grupları.",
    order: 15,
    isFeatured: false
  }
];

// Helper functions
export const getCategoryName = (id: string): string => {
  const category = DEFAULT_CATEGORIES.find(c => c.id === id);
  return category?.name || id;
};

export const getCategoryList = () => {
  return DEFAULT_CATEGORIES.map(({ id, name }) => ({ id, name }));
};

// Backward compatibility
export const categories = DEFAULT_CATEGORIES;

export const CATEGORIES = DEFAULT_CATEGORIES.reduce((acc, cat) => {
  acc[cat.id] = cat.name;
  return acc;
}, {} as Record<string, string>);

export type CategoryId = typeof DEFAULT_CATEGORIES[number]["id"];
